import { Item } from "app/models/item.inferface";

export class TenantsFakeDb
{
    public static tenants: Item[] = [
        {
            id: 1,
            description: 'Argentina'           
        },
        {
            id: 2,
            description: 'Brasil'          
        },
        {
            id: 3,
            description: 'Estados unidos'
           
        },
        {
            id: 4,
            description: 'Alemania'
          
        }
    ];
}
